module.exports = __webpack_public_path__ + "img/position_tbd.17e9576.png";